module.exports = __webpack_public_path__ + "static/story1-thumbnails-rect-250x125-99b7ae5467586d4677dc87c2277c9be8.jpg";